<template>
  <div class="home-view">
    <HomeSection />
    <IESSection />
    <InstrumentsSection />
    <WorldwideSection />
    <ContactSection />
    <DownloadsSection />
  </div>
</template>

<script>
import HomeSection from "@/sections/Home/HomeSection";
import IESSection from "@/sections/IES3/IESSection";
import InstrumentsSection from "@/sections/Instruments/InstrumentsSection";
import DownloadsSection from "@/sections/Downloads/DownloadsSection";
import WorldwideSection from "@/sections/Worldwide/WorldwideSection";
import ContactSection from "@/sections/Contact/ContactSection";
export default {
  name: "HomeView",
  components: {
    HomeSection,
    IESSection,
    InstrumentsSection,
    DownloadsSection,
    WorldwideSection,
    ContactSection
  }
};
</script>

<style scoped>
.home-view {
  background: white;
}
</style>
